import { alexforbesBrand } from '../brand/alexforbes';

const c = alexforbesBrand.colors;

/** Maps Trade.operation backend values to display labels and tag colors. */

export const TRADE_OPERATION_LABELS = {
  buy: 'Buy',
  sell: 'Sell',
  dividend_cash: 'Dividend (cash)',
  dividend_stock: 'Dividend (stock)',
  stock_split: 'Stock split',
  merger: 'Merger / acquisition',
  spinoff: 'Spin-off',
  other_corporate: 'Other corporate',
};

export const TRADE_OPERATION_COLORS = {
  buy: c.orange,
  sell: c.error,
  dividend_cash: c.teal,
  dividend_stock: c.tealLight,
  stock_split: c.orangeLight,
  merger: c.orangeDark,
  spinoff: c.tealDark,
  other_corporate: c.neutral,
};

export const MARKET_OPERATIONS = ['buy', 'sell'];

export const CORPORATE_OPERATIONS = [
  'dividend_cash',
  'dividend_stock',
  'stock_split',
  'merger',
  'spinoff',
  'other_corporate',
];

export const ALL_TRADE_OPERATIONS = [...MARKET_OPERATIONS, ...CORPORATE_OPERATIONS];

export const isMarketOperation = (op) => MARKET_OPERATIONS.includes(op);
